import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { exportImage } from '@progress/kendo-drawing';
import $ from "jquery";
import DropDownCellSeriesSelo from './myDropDownCellSeriesSelo';

var optionsTipoSelo = [];
var IdTipoSelo = null
var entidadeTipoSelo;
class DropDownCellTipoSelo extends Component {
  
  componentDidMount() {
    if(optionsTipoSelo.length == 0){
      (async () => {
      
        const data = {}
        const TipoSelo = await services.apiCall.requestApi(
            "/Selos/GetAllTiposSelo",
            data,
            "get"
        );
      console.log(TipoSelo , "tipo selooooooooooooooooooo")
        if(TipoSelo != null){
          TipoSelo.map((tipo) => (
            optionsTipoSelo.push({text: tipo.tipoSelo, value: tipo.idTipoSelo})
          ));
        }
      })();
    }
  }
  

  handleChange = e => {
    $("#id-SerieSelo .k-input").empty();
    $("#id-Intervalo .k-input").empty();
  
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
  });

    IdTipoSelo = e;
    if(entidadeTipoSelo){
      DropDownCellSeriesSelo.ChangeValueById(IdTipoSelo , entidadeTipoSelo);
    }else{
      DropDownCellSeriesSelo.ChangeValueById(IdTipoSelo , parseInt($("#instal_vinica_auto :selected").val().split("!")[1]));
    }
    
  }
  
  static GetEntidadeSerie(entidade){
    entidadeTipoSelo = entidade;
  }
  
  render() {
    console.log("Tipo de selo drop")
   
    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    // this.getAllData();
    
    return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
              popupSettings={{
                width: 'max-content',
              }}
              onChange={this.handleChange}
              value={optionsTipoSelo.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
              data={optionsTipoSelo}
              textField="text"
              id='id-DropDownCellTipoSelo'
            />
            : dataValue != null ? dataValue.text.toString() : undefined}
        </td>
    );
  
  }
    
}

export default DropDownCellTipoSelo;